import {
  DataGridPro,
  GridColDef,
  GridColumnMenu,
  GridColumnMenuProps,
} from '@mui/x-data-grid-pro';
import { Box, CircularProgress, SxProps } from '@mui/material';
import type {
  GridProSlotsComponent,
  GridSortModel,
} from '@mui/x-data-grid-pro';
// import { GridProSlotProps } from '@mui/x-data-grid-pro/models/gridProSlotProps';
import type { GridSlotsComponentsProps } from '@mui/x-data-grid-pro';
import { Theme } from '@emotion/react';
import { useMuiDataGridLocale } from '../../../../i18n/useMuiDataGridLocale';

type Rows<T> = T[];

interface ListDataGridProps<T extends { id: string | number }> {
  rows: Rows<T>;
  columns: GridColDef<T>[];
  loading?: boolean;
  pageSizeOptions?: number[];
  checkboxSelection?: boolean;
  slots?: Partial<GridProSlotsComponent>;
  slotProps?: Partial<GridSlotsComponentsProps>;
  height?: string | number; // prop for scrolling inside fixed box
  initialSortModel?: GridSortModel; //for passing initial sorting
  sx?: SxProps<Theme>;
}

/**
 * Settings for column item menu
 * @param props
 * @returns
 */

function CustomColumnMenu(props: GridColumnMenuProps) {
  return <GridColumnMenu {...props} />;
}

const ListDataGrid = <T extends { id: string | number }>({
  columns,
  rows,
  loading,
  pageSizeOptions,
  checkboxSelection,
  slots,
  slotProps,
  height,
  initialSortModel,
  sx,
}: ListDataGridProps<T>) => {
  const mergedSlots: Partial<GridProSlotsComponent> = {
    columnMenu: CustomColumnMenu,
    ...(slots ?? {}),
  };

  const localeText = useMuiDataGridLocale();

  return (
    <Box
      sx={{
        height: height ?? 'fit-content',
        overflow: 'auto',
        width: '100%',
        maxWidth: '100%',
        marginTop: '20px',
        ...sx,
      }}
    >
      {loading ? (
        <CircularProgress />
      ) : (
        <DataGridPro
          localeText={localeText}
          rows={rows}
          columns={columns}
          pageSizeOptions={pageSizeOptions}
          checkboxSelection={checkboxSelection}
          slots={mergedSlots}
          slotProps={slotProps}
          initialState={{
            sorting: {
              sortModel: initialSortModel ?? [],
            },
          }}
        />
      )}
    </Box>
  );
};

export default ListDataGrid;
